import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, GeneralRoutes } from '../../../constants';

const threePLProviderSection = [
  {
    value: `/${EnumDeskRoutes.settings}/${GeneralRoutes.manageBrands}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="3PL.manage-brands" />
      </div>
    ),
  },
];

const threePLSection = [
  {
    value: `/${EnumDeskRoutes.settings}/${GeneralRoutes.thirdParty}`,
    label: (
      <div className="capitalize">
        <FormattedMessage id="general.3pl" />
      </div>
    ),
  },
];

export { threePLProviderSection, threePLSection };
